import { Component, createContext, h, useContext } from "@lukekaalim/act";

const DebugContext = createContext(false);

export const Debug: Component<{ debug?: boolean }> = ({ children, debug = true }) =>
  h(DebugContext.Provider, { value: debug }, children);

export const useIsDebug = () => useContext(DebugContext);